export default __webpack_public_path__ + "static/media/business_card_landscape_3.5x2in.bef8ad3f.png";